import LeftMenu from '../../AnalyticsModule/Left'
import '../../AnalyticsModule/home.css'
import "../ECI/eciReport.css";
import { useNavigate } from "react-router-dom";
import { deepOrange, lime, teal, amber, blue, grey, lightBlue, orange, pink, purple, yellow } from '@mui/material/colors';
const CeoReport=()=> {
  let navigate = useNavigate();
  return (
    <LeftMenu>
      <div className="container-fluid pl-0 reports">
        <div className="row">
        <div class="col-md-4">
            <div class="card " style={{background:amber[100],border:`1px solid ${amber[800]}`}}>
              <div class="card-statistic-3 p-4 card-height-reports" onClick={() => navigate("/ceo/report/eroll-finalization-status-ceo-report")}>
                <div class="card-icon card-icon-large"><i class="fas fa-solid fa-signal mr-3"></i></div>
                <div class="row align-items-center mb-2 d-flex">
                  <div class="col-10 card-text-alignment ">
                    <h5 class="d-flex align-items-center mb-0">
                      e-Roll Finalization Status Report
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        <div class="col-md-4">
           <div class="card " style={{background:lightBlue[100],border:`1px solid ${lightBlue[800]}`}}>
              <div class="card-statistic-3 p-4 card-height-reports" onClick={() => navigate("/ceo/report/epb-generation-download-ceo-report")}>
                <div class="card-icon card-icon-large"><i class="fas fa-solid fa-envelopes-bulk mr-2"></i></div>
                <div class="row align-items-center mb-2 d-flex">
                  <div class="col-10 card-text-alignment-booked-report">
                    <h5 class="d-flex align-items-center mb-0">
                      e-Postal Ballot Generation/Downloading Report
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
         
          <div class="col-md-4">
           <div class="card " style={{background:purple[100],border:`1px solid ${purple[800]}`}}>
              <div class="card-statistic-3 p-4 card-height-reports" onClick={() => navigate("/ceo/report/epb-scanning-ceo-report")}>
                <div class="card-icon card-icon-large"><i className="fas fa-solid fa-qrcode mr-3"></i></div>
                <div class="row align-items-center mb-2 d-flex">
                  <div class="col-10 card-text-alignment">
                    <h5 class="d-flex align-items-center mb-0">
                      e-Postal Ballot Pre-Counting Report
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
 <div class="card " style={{background:pink[100],border:`1px solid ${pink[800]}`}}>
              <div class="card-statistic-3 p-4 card-height-reports" onClick={() => navigate("/ceo/report/counting-supervisor-ceo-report")}>
                <div class="card-icon card-icon-large"><i class="fas fa-solid fa-users-viewfinder mr-3"></i></div>
                <div class="row align-items-center mb-2 d-flex">
                  <div class="col-10 card-text-alignment">
                    <h5 class="d-flex align-items-center mb-0">
                      Counting Supervisor Report
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div class="col-md-4">
             <div class="card " style={{background:teal[100],border:`1px solid ${teal[800]}`}}>
              <div class="card-statistic-3 p-4 card-height-reports" onClick={() => navigate(`/${localStorage?.userrole}/report/epb-precounting-completion-statewise-${localStorage?.userrole}-report`)}>
                <div class="card-icon card-icon-large"><i className="fas fa-solid fa-qrcode mr-3"></i></div>
                <div class="row align-items-center mb-2 d-flex">
                  <div class="col-10 card-text-alignment">
                    <h5 class="d-flex align-items-center mb-0">
                    e-Postal Ballot Pre-Counting Completion Report 
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LeftMenu>
  )
}

export default CeoReport
